export enum OrderItemType {
    DEFAULT = 0,
    MENU_ARTICLE = 1,
    LUNCH_ARTICLE = 2
}
